<template>
  <div>
    <table id="datatable-comparing">
      <thead>
        <tr>
          <th style="width: 26%;">รายการ</th>
          <th style="width: 37%;">ข้อมูลเดิม (MSO-Logbook)</th>
          <th style="width: 37%;">ข้อมูลจากทะเบียนราษฎร์</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="info in infoToBeCompareBORA" :key="info.field">
          <td class="label p-2">
            <span v-if="info.field === 'address'" style="color: red;">*</span>
            {{ info.label }}:
          </td>
          <td class="rounded bg-gray-300 p-2">
            {{ info.text }}
          </td>
          <td class="rounded bg-gray-300 p-2" v-if="info.text == info.bora_text">
            {{ info.bora_text }}
          </td>
          <td class="rounded bg-[#dfaacc] p-2" v-else>
            {{ info.bora_text }}
          </td>
        </tr>
          <tr><td class="label p-2"></td><td colspan="2"><span style=" color: red;">*</span> <span style="color: darkgrey;">ข้อมูลที่อยู่จะไม่ถูกบันทึกลงระบบ MSO Logbook</span></td></tr>
        <tr>
          <td class="label p-2"></td>
          <td style="justify-items: center;">
          </td>
          <td style="justify-items: center;">
            <div class="col-span-12 flex items-center justify-end">
              <button
                class="btn btn-primary"
                @click="selectConnectModalForm"
                data-dismiss="modal"
              >
                เลือกใช้ข้อมูลจากทะเบียนราษฎร์
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <hr class="col-span-12 mt-4" />
  </div>
</template>

<script setup>
import { computed, ref, onMounted, inject, nextTick } from "vue";
import { useStore } from "vuex";
import axios from "axios";
import Swal from "sweetalert2";
const store = useStore();
const generateLogoHTML = ref("");
const cancelData = ref(false);
const openModalStatus = ref(false);
const connect_name = ref("BORA");
const img_connect_logo = ref("");
const props = defineProps({
  // eslint-disable-next-line vue/require-default-prop
  bora_data:Object,
  infoToBeCompareBORA: Array,
  infoData: Object,
});
const emit = defineEmits(['close-modal','update-state']);
const refreshMemberData = inject('refreshMemberData', null);
const swalCustom = Swal.mixin({
  customClass: {
    confirmButton: "btn btn-primary m-1",
    cancelButton: "btn btn-outline-secondary m-1",
  },
  buttonsStyling: false,
});

const selectConnectModalForm = async () => {
   const token = store.getters["userAuth/getToken"];
  
  swalCustom.fire({
    html: "ยืนยันบันทึกข้อมูลจาก ทะเบียนราษฎร์",
    icon: "info",
    showCancelButton: true,
    reverseButtons: true,
    confirmButtonText: 'ตกลง',
    cancelButtonText: 'ยกเลิก',
    allowOutsideClick: false,
    allowEscapeKey: true,
  }).then(async (result) => {
    if (result.isConfirmed) {
      try {
        // รวมข้อมูลบิดา/มารดา: ถ้า BORA ไม่มีบางฟิลด์ ให้เก็บค่าจากเดิมไว้
        let fatherUpdate = props.infoData?.father ? { ...props.infoData.father } : {};
        if (props.bora_data?.father) {
          fatherUpdate = {
            ...fatherUpdate,
            national_id: props.bora_data.father.national_id || fatherUpdate.national_id || '',
            name: props.bora_data.father.name || fatherUpdate.name || '',
            surname: props.bora_data.father.surname || fatherUpdate.surname || '',
            nationality: props.bora_data.father.nationality || fatherUpdate.nationality || ''
          };
        }
        if (Object.keys(fatherUpdate).length === 0) {
          fatherUpdate = null;
        }

        let motherUpdate = props.infoData?.mother ? { ...props.infoData.mother } : {};
        if (props.bora_data?.mother) {
          motherUpdate = {
            ...motherUpdate,
            national_id: props.bora_data.mother.national_id || motherUpdate.national_id || '',
            name: props.bora_data.mother.name || motherUpdate.name || '',
            surname: props.bora_data.mother.surname || motherUpdate.surname || '',
            nationality: props.bora_data.mother.nationality || motherUpdate.nationality || ''
          };
        }
        if (Object.keys(motherUpdate).length === 0) {
          motherUpdate = null;
        }

        // linking_system: ถ้ายังไม่มี BORA ให้เพิ่ม ถ้ามีแล้วให้อัปเดต updated_at
        let get_linking_system = [];
        const boraEntry = { system: "BORA", updated_at: new Date().toLocaleDateString('sv-SE') };
        if (props.infoData?.linking_system?.length) {
          const originalSystems = props.infoData.linking_system;
          const existingIndex = originalSystems.findIndex(item =>
            (typeof item === 'object' ? item.system : item) === 'BORA'
          );
          if (existingIndex !== -1) {
            get_linking_system = [...originalSystems];
            get_linking_system[existingIndex] = boraEntry;
          } else {
            get_linking_system = [...originalSystems, boraEntry];
          }
        } else {
          get_linking_system = [boraEntry];
        }

        let update_data = {
          "national_id": props.bora_data?.national_id || '',
          "title": props.bora_data?.title || '',
          "name": props.bora_data?.name || '',
          "surname": props.bora_data?.surname || '',
          "sex": props.bora_data?.sex || '',
          "nationality": props.bora_data?.nationality || '',
          "vital_status": props.bora_data?.vital_status || '',
          "birthdate": props.bora_data?.birthdate || '',
          "father": fatherUpdate,
          "mother": motherUpdate,
          "linking_system": get_linking_system
        };
console.log(update_data)
        const config = {
          url: `${process.env.VUE_APP_BASE_API}member/${props.infoData._id}`,
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": `application/json; charset=utf-8`,
          },
          data: {
            update: update_data
          }
        };

        const res = await axios(config);
      
        if (res.status === 200 || res.status === 201) {
           if (refreshMemberData) {
    await refreshMemberData();
  }

  await new Promise(resolve => setTimeout(resolve, 300));
  Swal.close();
  await swalCustom.fire({
    html: `<div style="font-size:18px;"><b/>บันทึกข้อมูลสำเร็จ</div>`,
    icon: 'success',
    timer: 2000,
    confirmButtonText: "ปิด",
  });
        } else {
          throw new Error('Failed to update member');
        }
      } catch (error) {
        console.error("Error updating member from BORA:", error);
        swalCustom.fire({
          text: "ทำรายการไม่สำเร็จ โปรดลองอีกครั้ง",
          icon: "warning",
          confirmButtonText: "ปิด",
        });
      }
    }
  }).catch((error) => {
    console.error("BORA: Error in selectConnectModalForm:", error);
  });
};
</script>

<style>
#datatable-comparing {
  border-collapse: separate;
  border-spacing: 5px;
  width: 100%;
}
.label {
  vertical-align: text-top;
}
@media screen and (max-width: 372px) {
  /* 1. ซ่อน Header */
  #datatable-comparing thead {
    display: none;
  }

  /* 2. ทำให้แถวเป็นบล็อกแนวตั้ง */
  #datatable-comparing tr {
    display: block;
    margin-bottom: 10px;
    border: 1px solid #ccc;
  }

  /* 3. ทำให้เซลล์เป็นบล็อกแนวตั้ง และเพิ่ม Label */
  #datatable-comparing td {
    display: block;
    text-align: right;
    padding-left: 50%; /* เว้นที่ให้ Label */
    position: relative;
  }

  /* 4. ใช้ ::before เพื่อใส่ชื่อคอลัมน์เป็น Label */
  #datatable-comparing td::before {
    content: attr(data-label); /* ดึง Label จาก Attribute ใน HTML */
    position: absolute;
    left: 6px;
    font-weight: bold;
  }
}
</style>
